module.exports = __webpack_public_path__ + "img/thumb-havermoutkoekjes-met-dadels-en-abrikozen.07d4c268.jpeg";